import { EnvironmentName } from 'projects/shared/src/lib/core/enums/environment-name.enum';
import { ProjectName } from 'projects/shared/src/lib/core/enums/project-name.enum';

export const environment = {
  production: false,
  name: EnvironmentName.Test,
  projectName: ProjectName.Heorot,
  version: '1.0.0',
  build: '',
  baseApiUrl: 'https://taranisapi-dev.sensotec.be',
  urlVersion: '/api/v1',
  authorityUrl: 'https://test.lexipoort.nl',
  identityClientId: 'Rekenradar',
  isRekensprintEnabled: true,
  isLegacyWallToggleEnabled: true,
  lexipoort: {
    dashboard: 'https://test.lexipoort.nl/account/dashboard',
    knowledgeBase: 'https://app-test.lexipoort.nl/nl/kennisbank/lexipoort',
    manuals: 'https://app-test.lexipoort.nl/nl/support/handleidingen-en-release-notes',
    feedback: 'https://app-test.lexipoort.nl/nl/support/helpdesk'
  },
  lexima: {
    roadmap: 'https://lexima.nl/roadmap-bareka-en-rekensprint'
  },
  applicationName: null,
  azureBlobBaseUrl: 'https://sensotecstrekenappsdev.blob.core.windows.net/assets/',
};
